import React from 'react';
import { FileTextIcon, DumbbellIcon, TargetIcon, UsersIcon, CheckIcon } from 'lucide-react';
const tags = ['U10-U12', 'U13-U15', 'U17-U19', 'Physical Conditioning', 'Tactics', 'Scouting'];
const stats = [{
  icon: FileTextIcon,
  value: '300+',
  label: 'Pages'
}, {
  icon: DumbbellIcon,
  value: '200+',
  label: 'Sessions'
}, {
  icon: TargetIcon,
  value: '101',
  label: 'Shooting Drills'
}, {
  icon: UsersIcon,
  value: 'All',
  label: 'Age Groups'
}];
export function SolutionSection() {
  return <section className="w-full bg-white py-20 px-4" data-id="element-224">
      <div className="max-w-5xl mx-auto" data-id="element-225">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-12" data-id="element-226">
          <div className="inline-flex items-center gap-2 bg-[#0A0A0A] text-white font-bold text-[11px] sm:text-xs px-5 py-2 rounded-full mb-8 tracking-wider uppercase shadow-md" data-id="element-227">
            🏆 The Most Complete System for Coaches Worldwide
          </div>

          <h2 className="text-4xl sm:text-6xl font-black text-[#0A0A0A] mb-4 tracking-tight" data-id="element-228">
            BASKETBALL <span className="text-[#FF6B00]" data-id="element-229">READY 360™</span>
          </h2>

          <div className="inline-flex items-center gap-2 mb-6" data-id="element-230">
            <span className="h-px w-8 bg-[#FF6B00]" data-id="element-231" />
            <p className="text-[#FF6B00] text-base sm:text-lg font-black uppercase tracking-widest" data-id="element-232">
              6 Volumes + 5 Bonuses
            </p>
            <span className="h-px w-8 bg-[#FF6B00]" data-id="element-233" />
          </div>

          <p className="text-[#5A5A66] text-base sm:text-lg mx-auto font-medium leading-relaxed" data-id="element-234">
            Over 300 pages of training sessions, professional shooting drills,
            tactics, technique, physical conditioning and team management —{' '}
            <strong className="text-[#0A0A0A]" data-id="element-235">all done for you.</strong>
          </p>
        </div>

        {/* Stat cards */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-12" data-id="element-236">
          {stats.map(({
          icon: Icon,
          value,
          label
        }) => <div key={label} className="bg-[#FAFAFA] border border-[#E5E5EA] rounded-2xl p-6 text-center shadow-sm flex flex-col items-center" data-id="element-237">
              <span className="flex items-center justify-center w-12 h-12 rounded-xl bg-[#FF6B00]/10 mb-4" data-id="element-238">
                <Icon className="w-6 h-6 text-[#FF6B00]" strokeWidth={2.5} data-id="element-239" />
              </span>
              <div className="text-3xl sm:text-4xl font-black text-[#0A0A0A] tracking-tight leading-none mb-1" data-id="element-240">
                {value}
              </div>
              <div className="text-[#5A5A66] text-xs sm:text-sm font-bold uppercase tracking-wider" data-id="element-241">
                {label}
              </div>
            </div>)}
        </div>

        {/* Coverage tags */}
        <div className="bg-[#FAFAFA] border border-[#E5E5EA] rounded-2xl p-6 sm:p-8" data-id="element-242">
          <p className="text-center text-[#0A0A0A] text-xs font-black uppercase tracking-widest mb-5" data-id="element-243">
            Full coverage, every category
          </p>
          <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-3" data-id="element-244">
            {tags.map(tag => <span key={tag} className="inline-flex items-center gap-1.5 bg-white border border-[#E5E5EA] text-[#0A0A0A] text-xs sm:text-sm font-bold px-4 py-2 rounded-full shadow-sm" data-id="element-245">
                <CheckIcon className="w-3.5 h-3.5 text-[#00C853]" strokeWidth={3} data-id="element-246" />
                {tag}
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}